module.exports = __webpack_public_path__ + "img/greg-williams.9cdce07b.jpg";